var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","stroke":"currentColor","stroke-width":"2","height":_vm.size,"width":_vm.size,"viewBox":"0 0 24 24"}},[_c('line',{attrs:{"x1":"0.75","y1":"12","x2":"23.25","y2":"12"}})])}
var staticRenderFns = []

export { render, staticRenderFns }